import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSlideToggleChange, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Subject, throwError } from 'rxjs';
import { catchError, map, takeUntil, tap } from 'rxjs/operators';
import { AppConfig, DataService } from 'src/app/_helpers';
import { EventData } from 'src/app/_models/events.interface';
import { EventsService } from 'src/app/_services';
import { icons } from 'src/app/sharedcomp/constans/icons.constans';
import { ModalEditEventComponent } from './Modal/modal-edit-event.component';
import { element } from 'protractor';
import { EventsNewVersionService } from './events-new-version.service';


@Component({
  selector: 'app-events-new-version',
  templateUrl: './events-new-version.component.html',
  styleUrls: ['./events-new-version.component.css',
    '../../../../assets/css/new-badges-chips-theme.css',
    '../../../../assets/css/new-component-view.css',
    '../../../../assets/css/new-form-elements.css',
    '../../../../assets/css/new-buttons-theme.css',
    '../../../sharedcomp/sidebar/sidebar.component.css'
  ]
})
export class EventsNewVersionComponent implements OnInit, OnDestroy {

  private unsubcribe$ = new Subject<void>();

  customerPublicId: string;
  columnsToDisplay: string[] = ['parameter', 'status', 'actions'];
  dataSource = new MatTableDataSource<EventData>([]);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayLoaderSpinner: boolean = false;
  totalSize: number = 0;
  pageSize: number;
  PageSizeOptions: number[];
  icons: typeof icons;

  constructor(private eventService: EventsService, private router: Router, private spinnerService: Ng4LoadingSpinnerService,
    private dataService: DataService, private modalService: NgbModal, private eventsServices: EventsNewVersionService
  ) {
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
  }

  ngOnInit() {
    this.icons = icons;
    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customerPublicId = localStorage.getItem('companyId');
      }
    }
    else {
      this.customerPublicId = localStorage.getItem('subcompanyId');
    };

    this.eventsServices.public_id = this.customerPublicId
    this.getEventList();
  }

  ngOnDestroy(): void {
    this.unsubcribe$.next();
    this.unsubcribe$.complete();
  }

  loadSpinnerStatus() {
    this.dataService.loadSpinnerSubject$
      .pipe(
        tap(status => {
          if (status) {
            this.spinnerService.show();
          } else {
            this.spinnerService.hide();
          }
        })
      )
      .subscribe();
  }

  getEventList() {
    this.displayLoaderSpinner = true;
    this.eventService.getEventsList(this.customerPublicId)
      .pipe(
        takeUntil(this.unsubcribe$),
        map((response) => {
          if (response) {
            this.dataSource.data = response.data
            this.totalSize = response.data.length
            this.displayLoaderSpinner = false;
            this.spinnerService.hide();
          }
        }),
        catchError(
          (error: HttpErrorResponse) => {
            this.displayLoaderSpinner = false;
            this.spinnerService.hide();
            return throwError(error);
          }
        )
      ).subscribe()
  }

  updateStatus(element: EventData, event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const newStatus = inputElement.checked ? 'ACTIVE' : 'INACTIVE';
    const updatedItem = { ...element, status: newStatus };

    this.eventService.updateEventsStatus(element.public_id, updatedItem).subscribe(
      response => {
        element.status = newStatus;
      },
      error => {
        console.error('Error al actualizar el estado', error);
        inputElement.checked = !inputElement.checked;
      }
    );
  }

  open(element) {
    const modalRef = this.modalService.open(ModalEditEventComponent, { centered: true, windowClass: 'custom-modal-width' });
    modalRef.componentInstance.public_id = element.public_id
    modalRef.result.then((result) => {
      console.log('Modal closed with result:', result);
    }, (reason) => {
      console.log('Modal dismissed with reason:', reason);
    });
  }

}
